import React, { FC } from "react";
import clsx from "clsx";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { COLORS } from "../../../../constants";
import { ColorName } from "../../../../types";

export const useStyles = makeStyles(() => ({
  content: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  leftSection: {
    display: "flex",
  },
  rightSection: {
    textAlign: "right",
  },
  image: {
    width: 60,
    height: 60,
    backgroundSize: "100% auto",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  },
  leftTextContainer: {
    maxWidth: 356,
    marginRight: 15,
    marginLeft: 15,
  },
  lRow0: {
    fontSize: 15,
    color: "#231F20",
    lineHeight: 1.1,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  lRow1: {
    fontSize: 14,
    color: "#231F20",
    marginTop: 5,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  lRow0text0: {
    fontWeight: "bold",
  },
  lRow0text1: {
    marginLeft: 15,
  },
  lRow1text1: {
    marginLeft: 16,
    fontWeight: "bold",
  },
  lRow2: {
    fontSize: 12,
    color: "#4B4B4B",
    marginTop: 3,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  lRow2text1: {
    fontWeight: "bold",
  },
  rRow0: {
    display: "flex",
    justifyContent: "flex-end",
  },
  rRow0text0: {
    fontSize: 12,
    color: "#FFFFFF",
    padding: "4px 18px",
    borderRadius: 18,
  },
  rRow0text0BackgroundOnline: {
    backgroundColor: "#7D9EF1",
  },
  rRow0text0BackgroundOnCampus: {
    backgroundColor: COLORS.message.main,
  },
  rRow1: {
    fontSize: 13,
    color: "#231F20",
    marginTop: 15,
    lineHeight: 1,
    maxHeight: 22,
    overflow: "hidden",
    wordBreak: "break-all",
  },
  rRow1text0: {
    fontSize: 13,
    fontWeight: "bold",
    color: "#231F20",
  },
  rRow1text1: {
    fontSize: 13,
    color: "#858997",
    marginRight: 10,
    textDecoration: "line-through",
  },
}));

interface IApplicationCardHeaderProps {
  content: {
    leftSection: {
      image?: string;
      lRow0?: {
        text0?: string;
        text1?: string;
      };
      lRow1?: {
        text0?: string;
        text1?: string;
      };
      lRow2?: {
        text0?: string;
        text1?: string;
      };
    };
    rightSection: {
      rRow0?: {
        text0?: string;
        text0BackgroundColor?: string;
      };
      rRow1?: {
        text0?: string;
        text1?: string;
      };
    };
  };
}

export const ApplicationCardHeader: FC<IApplicationCardHeaderProps> = (
  props,
) => {
  const classes = useStyles();

  const {
    content: {
      leftSection: { image, lRow0, lRow1, lRow2 },
      rightSection: { rRow0, rRow1 },
    },
  } = props;

  return (
    <div className={classes.content}>
      <div className={classes.leftSection}>
        {!!image && (
          <img
            alt={"School Logo"}
            src={image}
            className={classes.image}
            width={60}
            height={60}
          />
        )}
        <div className={classes.leftTextContainer}>
          {!!lRow0 && (
            <div className={classes.lRow0}>
              {!!lRow0.text0 && (
                <span className={classes.lRow0text0}>{lRow0.text0}</span>
              )}
              {!!lRow0.text1 && (
                <span className={classes.lRow0text1}>{lRow0.text1}</span>
              )}
            </div>
          )}
          {!!lRow1 && (
            <div className={classes.lRow1}>
              {!!lRow1.text0 && lRow1.text0}
              {!!lRow1.text1 && (
                <span className={classes.lRow1text1}>{lRow1.text1}</span>
              )}
            </div>
          )}
          {!!lRow2 && (
            <div className={classes.lRow2}>
              {!!lRow2.text0 && lRow2.text0}
              {!!lRow2.text1 && (
                <span className={classes.lRow2text1}>{lRow2.text1}</span>
              )}
            </div>
          )}
        </div>
      </div>
      <div className={classes.rightSection}>
        {!!rRow0 && (
          <div className={classes.rRow0}>
            {!!rRow0.text0 && (
              <div
                className={clsx(
                  classes.rRow0text0,
                  rRow0.text0BackgroundColor === ColorName.ONLINE
                    ? classes.rRow0text0BackgroundOnline
                    : classes.rRow0text0BackgroundOnCampus,
                )}
              >
                {rRow0.text0}
              </div>
            )}
          </div>
        )}
        {!!rRow1 && (
          <div className={classes.rRow1}>
            {!!rRow1.text1 && (
              <span className={classes.rRow1text1}>{rRow1.text1}</span>
            )}
            {!!rRow1.text0 && (
              <span className={classes.rRow1text0}>{rRow1.text0}</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
